import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropdown-user',
  templateUrl: './dropdown-user.component.html',
})

export class DropdownUserComponent  {

  public user : any =  {
    app: 'SmartAdmin',
    name: 'Dr. Codex Lantern',
    email: 'drlantern@gotbootstrap.com',
    avatar: 'avatar-m.png',
    nameuser: sessionStorage.getItem("fname")+" "+sessionStorage.getItem("lname")
  };

  constructor() { }
  // this.user = {
  //   app: 'SmartAdmin',
  //   name: 'Dr. Codex Lantern',
  //   email: 'drlantern@gotbootstrap.com',
  //   avatar: 'avatar-m.png',
  //   nameuser: sessionStorage.getItem("fname")+" "+sessionStorage.getItem("lname")
  // };

  logout(){}

}
